export const footerText = '';
